import auth from '../../services/api/auth'
import {getAuthState} from "@/store/States"
import {cancel} from '@/services/api/api'

const state = getAuthState()

function storeUser(user) {
    localStorage.setItem('user', JSON.stringify(user))
}

function deleteUser() {
    localStorage.removeItem('user')
}

const getters = {
    isLoggedIn: state => state.user.token,
    isLoading: state => state.status === 'loading',
    isInfoLoading: state => state.infoStatus === 'loading',
    isRegisterLoading: state => state.registerStatus === 'loading',
    getRegisterError: state => state.registerStatus === 'error' ? state.registerError : '',
    isSuccess: state => state.status === 'success',
    getPasswordError: state => state.status === 'error' ? state.passwordError : '',
    getUserError: state => state.status === 'error' ? state.userError : '',
    getUserInfo: state => state.user
}

const actions = {
    async login({commit}, credentials) {
        commit('loading')

        let response
        try {
            response = await auth.login(credentials)
        } catch (e) {
            return commit('error')
        }
        if (response.Success) {
            delete response.Success
            response['userid'] = credentials.userid
            storeUser(response)
            commit('success', response)
        } else {
            commit('error', response)
        }
    },

    async signout({dispatch, commit, state}, doAsync = true) {
        commit('loading')

        let response
        if (doAsync) {
            try {
                response = await auth.signout(state.user.token)
            } catch (e) {
                commit('error')
            }
        }
        deleteUser()
        cancel()
        await dispatch('resetState', {}, {root: true})
        commit('success', response)
    },

    async fetchUserInfo({commit, state}) {
        if (!state.user.token)
            return

        commit('infoLoading')

        let response
        try {
            response = await auth.getUserInfo(state.user.token)
        } catch (e) {
            return commit('infoError')
        }
        if (response.Success) {
            commit('setUserInfo', response)
        }
    },

    async collectReward({commit, state}) {
        if (!state.user.token)
            return

        let response
        try {
            response = await auth.collectReward(state.user.token)
        } catch (e) {
        }
        if (response.Success) {
            commit('updateScoins', response.scoins)
            return response
        }
    },

    async register({commit, dispatch}, data) {
        commit('registerLoading')

        const cred = {
            userid: data.userid,
            password: data.password
        }

        let response
        try {
            response = await auth.signon(data)
        } catch (e) {
            return commit('registerError')
        }
        if (response.Success) {
            await dispatch('login', cred)
            commit('registerSuccess')
        } else {
            commit('registerError', response)
        }
    },

    async updateProfile({commit, dispatch}, data) {
        commit('registerLoading')

        data["token"] = state.user.token
        // data["userid"] = state.user.userid

        const cred = {
            userid: '',
            password: data.password
        }

        let response
        try {
            response = await auth.updateProfile(data)
        } catch (e) {
            return commit('registerError')
        }
        if (response.Success) {
            cred.userid = response.userid
            await dispatch('login', cred)
            commit('registerSuccess')
        } else {
            commit('registerError', response)
        }
    }
}

const mutations = {
    resetState(state) {
        Object.assign(state, getAuthState())
    },
    updateScoins(state, scoins) {
        state.user.scoins = scoins
        storeUser(state.user)
    },
    deltaScoins(state, delta) {
        state.user.scoins += delta
        storeUser(state.user)
    },
    loading(state) {
        state.status = 'loading'
    },
    infoLoading(state) {
        state.infoStatus = 'loading'
    },
    infoError(state) {
        state.infoStatus = 'error'
    },
    registerLoading(state) {
        state.registerStatus = 'loading'
    },
    registerSuccess(state) {
        state.registerStatus = 'success'
    },
    success(state, user) {
        if (!user)
            return
        state.status = 'success'
        state.user = user
    },
    setRewardTime(state, time) {
        state.user.RewardMilliSecSinceEpoch = time
        storeUser(state.user)
    },
    error(state, res) {
        state.status = 'error'
        if (res)
            if (res.Error === -3001) {
                state.userError = res.Message
                state.passwordError = ''
            } else if (res.Error === -3003) {
                state.passwordError = res.Message
                state.userError = ''
            }
    },
    registerError(state, res) {
        state.registerStatus = 'error'
        if (res) {
            state.registerError = res.Message
        }
    },
    logout(state) {
        state.status = ''
        state.userError = ''
        state.passwordError = ''
        state.user.token = ''
        state.user.SCoins = ''
    },
    setUserInfo(state, info) {
        state.user.SCoins = info.scoins
        state.user.fname = info.fname
        state.user.photo = info.photo
        state.infoStatus = 'success'
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
